import { z } from "zod";
import { CycleReviewTypes } from "./reviewTypes.ts";

export const CycleQuestionKinds = ["rating", "choice"] as const;

export type CycleQuestionKind = (typeof CycleQuestionKinds)[number];

const CycleQuestionWithheldReasons = ["below-minimum-cohort"] as const;

export const CycleQuestionAnswerSchema = z.object({
    value: z.number(),
    label: z.string(),
    count: z.number().int().min(0)
});

export type CycleQuestionAnswer = z.infer<typeof CycleQuestionAnswerSchema>;

export const CycleQuestionResultSchema = z.object({
    questionId: z.string(),
    title: z.string(),
    description: z.string().optional(),
    kind: z.enum(CycleQuestionKinds),
    askedOf: z.array(z.enum(CycleReviewTypes)),
    allowMultiple: z.boolean(),
    answers: z.array(CycleQuestionAnswerSchema),
    responseCount: z.number().int().min(0),
    average: z.number().nullable(),
    scaleMax: z.number().nullable(),
    withheldReason: z.enum(CycleQuestionWithheldReasons).optional()
});

export type CycleQuestionResult = z.infer<typeof CycleQuestionResultSchema>;

export const CycleQuestionSectionSchema = z.object({
    sectionId: z.string(),
    title: z.string(),
    position: z.number().int().positive(),
    questions: z.array(CycleQuestionResultSchema)
});

export type CycleQuestionSection = z.infer<typeof CycleQuestionSectionSchema>;

export const CycleQuestionResultsSchema = z.object({
    sections: z.array(CycleQuestionSectionSchema)
});

export type CycleQuestionResults = z.infer<typeof CycleQuestionResultsSchema>;
